import { Input, KeyCode } from "../../../lib/Input";
import Ability from "../../Ability";
import Player from "../../Player";

export default class ShieldOvercharge extends Ability {

    constructor(player: Player) {
        super(player, {
            cooldown: 25,
            duration: 5,
            energyCost: 40,
            icon: 2,
            trigger: KeyCode.Digit3,
            triggerType: Input.GetKeyDown,
            info: `Shield Overcharge (25s cooldown) - Overcharges your shields, reducing damage taken by 33% for 5 seconds.`
        })
    }

    onUse(): void {
        this.player.damageReductionModifier = 0.333;
    }

    onDurationEnd(): void {
        this.player.damageReductionModifier = 0;
    }
}